import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pagenotauthorized',
  templateUrl: './pagenotauthorized.component.html',
  styleUrls: ['./pagenotauthorized.component.scss']
})
export class PagenotauthorizedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
